<template>
  <div v-if="!item.hidden">
    <template v-if="hasOneShowingChild(item.children, item) && !onlyOneChild.children">
      <router-link :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)">
          <span>{{ onlyOneChild.meta.title }}</span>
        </el-menu-item>
      </router-link>
    </template>

    <el-submenu v-else :index="resolvePath(item.path)">
      <template slot="title">
        <span>{{ item.meta && item.meta.title }}</span>
      </template>
      <router-link
        v-for="child in item.children"
        :key="child.path"
        :to="resolvePath(child.path)"
      >
        <el-menu-item :index="resolvePath(child.path)">
          <span>{{ child.meta.title }}</span>
        </el-menu-item>
      </router-link>
    </el-submenu>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    item: { type: Object, required: true },
    basePath: { type: String, default: '' }
  },
  data() {
    return {
      onlyOneChild: null
    }
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showing = children.filter(item => !item.hidden)
      if (showing.length === 1) {
        this.onlyOneChild = showing[0]
        return true
      }
      if (showing.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
        return true
      }
      return false
    },
    resolvePath(routePath) {
      if (/^(https?:|mailto:|tel:)/.test(routePath)) return routePath
      if (routePath.startsWith('/')) return routePath
      const base = this.basePath.replace(/\/$/, '')
      return `${base}/${routePath}`.replace(/\/+/g, '/')
    }
  }
}
</script>
